import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { AnimalsHero } from '../components/animals/AnimalsHero';
import { AnimalsChallenge } from '../components/animals/AnimalsChallenge';
import { AnimalsSolution } from '../components/animals/AnimalsSolution';
import { AnimalsIntelligence } from '../components/animals/AnimalsIntelligence';
import { AnimalsFinalCTA } from '../components/animals/AnimalsFinalCTA';
import { trackEvent } from '../utils/analytics';
export function AnimalLicensing() {
  useEffect(() => {
    trackEvent('Page Viewed', {
      page: 'AnimalLicensing'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8009" data-mp="1dfqqsyp4co9x">
      <Header data-id="element-8010" data-mp="19g00sx7f2c6g" />
      <main className="pt-[120px]" data-id="element-8011" data-mp="19fglzpd2c3wn">
        <section className="relative pb-16 overflow-hidden bg-[#FCFCFE]" data-id="element-8012" data-mp="19imb34loz5sd">
          <div className="pointer-events-none absolute -top-40 left-[30%] w-[700px] h-[600px] rounded-full bg-[#EEEDFD] opacity-60 blur-[150px]" aria-hidden="true" data-id="element-8013" data-mp="2ovffpvlxnxdd" />
          <AnimalsHero data-id="element-8014" data-mp="d1bbme09wjgw" />
        </section>
        <section className="relative py-16 xl:py-0 bg-white overflow-hidden" data-id="element-8015" data-mp="d08kq62yah0z">
          <AnimalsChallenge data-id="element-8016" data-mp="hya996j5b8ju" />
        </section>
        <section className="relative py-16 xl:pt-10 xl:pb-16 bg-white overflow-hidden" data-id="element-8017" data-mp="m16rux8or4ns">
          <AnimalsSolution data-id="element-8018" data-mp="lzdnxppgiyjh" />
        </section>
        <section className="relative py-16 xl:pt-10 xl:pb-20 bg-white overflow-hidden" data-id="element-8019" data-mp="qz8bbja0x5zs">
          <AnimalsIntelligence data-id="element-8020" data-mp="3qg7ozq0fkuuu" />
        </section>
        <section className="relative py-16 xl:pt-6 xl:pb-20 bg-white overflow-hidden" data-id="element-8021" data-mp="3qdbru3weqa7g">
          <AnimalsFinalCTA data-id="element-8022" data-mp="3uh9rcfpn9n11" />
        </section>
      </main>
      <Footer data-id="element-8023" data-mp="3agpraqxvlvz" />
    </div>;
}